module.exports = __webpack_public_path__ + "img/slide1-content1.3524e4af.png";